import { gql } from '@apollo/client';

const LOCALES_QUERY = gql`
    query locales {
        locales {
            totalCount
            edges {
                node {
                    code
                    label
                    labelEnUs
                }
            }
        }
    }
`;

export default LOCALES_QUERY;
